export default __webpack_public_path__ + "static/media/footer.4092f03f.png";